import * as api from './middleware/api.middleware';
import { IAvailableSenderInformation } from '../interfaces/sender.interfaces';
import { IResponseCollection } from '../interfaces/general.interfaces';
import { staticConfig } from '../config/static';
import { IOrganisation } from '../interfaces/organisations.interfaces';

const serviceUrl = '/senderservice/v1';

export function getAvailableSenders(mailboxId: string) {
    return api.get<IResponseCollection<IAvailableSenderInformation>>(`${serviceUrl}/sender-information/${mailboxId}`);
}

export function getSenderOrganisations(cvrNumbers: string[]) {
    const queryParams = cvrNumbers
        .map(function (cvr, idx) {
            return 'cvrNumbers[' + idx + ']=' + cvr;
        })
        .join('&');
    const url = serviceUrl + '/sender-organisations?' + queryParams;
    return api.get<IResponseCollection<IOrganisation>>(url);
}

export function getSenderOrganisationLogo(organisationId: string, mimeType: string) {
    const url =
        staticConfig.apiBaseUrl + serviceUrl + `/sender-organisation/${organisationId}/logo?mimeType=${mimeType}`;
    return new Promise<any>((resolve, reject) => {
        fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': mimeType },
            credentials: 'include',
        })
            .then((response) => response.blob())
            .then((blob) => {
                resolve(blob);
            })
            .catch((err) => {
                reject(err);
            });
    });
}
